'use client';

import { c as _c } from "react/compiler-runtime";
import { UnauthQueryOptions } from '@/api';
import { useUrlMultiSelect } from '../../_hooks/useUrlFilterController';
import type { FilterOption } from '../../constants';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSidebarShell } from '../FilterSidebarShell';
import { MultiSelectFilterSection } from '../MultiSelectFilterSection';
const tagQueryOptions = {
  ...UnauthQueryOptions['get:/wello/v2/allows/best-contents-tag'](),
  select: ({
    context
  }: {
    context?: {
      bestContentsTagId?: string;
      name?: string;
    }[];
  }): FilterOption<string>[] => (context ?? []).filter((item): item is {
    bestContentsTagId: string;
    name: string;
  } => Boolean(item.bestContentsTagId && item.name)).map(item => ({
    value: item.bestContentsTagId,
    label: item.name
  }))
};
interface PolicyInfoFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
}
export function PolicyInfoFilter(t0) {
  const $ = _c(18);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer
  } = t0;
  const tag = useUrlMultiSelect("guideTags");
  let t1;
  if ($[0] !== tag.toggle || $[1] !== tag.values) {
    t1 = <MultiSelectFilterSection variant="sidebar" title={"\uD0DC\uADF8"} queryOptions={tagQueryOptions} values={tag.values} onToggle={tag.toggle} />;
    $[0] = tag.toggle;
    $[1] = tag.values;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== tag.clear) {
    t2 = <FilterSidebarShell onReset={tag.clear}>{t1}</FilterSidebarShell>;
    $[3] = t1;
    $[4] = tag.clear;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== tag.toggle || $[7] !== tag.values) {
    t3 = <MultiSelectFilterSection variant="drawer" title={"\uD0DC\uADF8"} queryOptions={tagQueryOptions} values={tag.values} onToggle={tag.toggle} />;
    $[6] = tag.toggle;
    $[7] = tag.values;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isDrawerOpen || $[10] !== onApplyDrawer || $[11] !== onCloseDrawer || $[12] !== t3 || $[13] !== tag.clear) {
    t4 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={tag.clear} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t3}</FilterDrawerShell>;
    $[9] = isDrawerOpen;
    $[10] = onApplyDrawer;
    $[11] = onCloseDrawer;
    $[12] = t3;
    $[13] = tag.clear;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t2 || $[16] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}